import { Typography, Box, useTheme } from "@mui/material";
import { tokens } from "../theme";

const styles = {
  box: {
    mb: "16px",
  },
  title: (colors) => ({
    color: colors.grey[100],
    fontWeight: 700,
    fontSize: 22,
    letterSpacing: "-0.015em",
    m: "0 0 2px 0",
  }),
  subtitle: (colors) => ({
    color: colors.grey[400],
    fontSize: 13,
  }),
};

const Header = ({ title, subtitle }) => {
  const theme = useTheme();
  const colors = tokens(theme.paletteId);
  return (
    <Box sx={styles.box}>
      <Typography variant="h2" sx={styles.title(colors)}>
        {title}
      </Typography>
      <Typography variant="body2" sx={styles.subtitle(colors)}>
        {subtitle}
      </Typography>
    </Box>
  );
};

export default Header;
